import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminBoxFileRequest } from './admin-box-file.request';
import { AdminBoxStatus } from '../../enums/admin-box-status';
import { AdminDictionaryProductAttributeRequest } from '@web/shared/module/dictionary';
import { AdminBoxCharacteristicRequest } from './admin-box-characteristic.request';
import { dateWithOffsetSerializer } from '@web/common';
import { AdminBoxCosmeticRequest } from './admin-box-cosmetic.request';

@jsonObject
export class AdminBoxUpdateRequest {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly cosmeticBrandId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly boxCategoryId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly warehouseGoodId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly illustrationFileId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly featuredFileId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly symbolFileId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly password?: Nillable<string>;

  @jsonMember(String)
  public readonly price?: Nillable<string>;

  @jsonMember(Number)
  public readonly maxQuantityPerOrder?: Nillable<number>;

  @jsonMember(Number)
  public readonly availableQuantity?: Nillable<number>;

  @jsonMember(String)
  public readonly contentPreviewUrl?: Nillable<string>;

  @jsonMember(Boolean)
  public readonly currentEdition?: Nillable<boolean>;

  @jsonMember(String)
  public readonly status!: AdminBoxStatus;

  @jsonArrayMember(AdminBoxFileRequest)
  public readonly files?: Nillable<AdminBoxFileRequest[]>;

  @jsonMember(Date, { serializer: dateWithOffsetSerializer() })
  public readonly publishedAt?: Nillable<Date>;

  /* prettier-ignore */
  @jsonArrayMember(AdminDictionaryProductAttributeRequest)
  public readonly attributes?: Nillable<AdminDictionaryProductAttributeRequest[]>;

  /* prettier-ignore */
  @jsonArrayMember(AdminBoxCharacteristicRequest)
  public readonly characteristics?: Nillable<AdminBoxCharacteristicRequest[]>;

  @jsonArrayMember(AdminBoxCosmeticRequest)
  public readonly cosmetics?: Nillable<AdminBoxCosmeticRequest[]>;

  public constructor(
    private readonly data: {
      attributes?: Nillable<AdminDictionaryProductAttributeRequest[]>;
      characteristics?: Nillable<AdminBoxCharacteristicRequest[]>;
      boxCategoryId?: Nillable<Guid>;
      warehouseGoodId?: Nillable<Guid>;
      contentPreviewUrl?: Nillable<string>;
      cosmeticBrandId?: Nillable<Guid>;
      currentEdition?: Nillable<boolean>;
      featuredFileId?: Nillable<Guid>;
      files?: Nillable<AdminBoxFileRequest[]>;
      illustrationFileId?: Nillable<Guid>;
      availableQuantity?: Nillable<number>;
      maxQuantityPerOrder?: Nillable<number>;
      name: string;
      cosmetics?: Nillable<AdminBoxCosmeticRequest[]>;
      password?: Nillable<string>;
      price?: Nillable<string>;
      slug: string;
      status: AdminBoxStatus;
      symbolFileId?: Nillable<Guid>;
      publishedAt?: Nillable<Date>;
    },
  ) {
    this.attributes = this.data.attributes;
    this.characteristics = this.data.characteristics;
    this.boxCategoryId = this.data.boxCategoryId;
    this.warehouseGoodId = this.data.warehouseGoodId;
    this.contentPreviewUrl = this.data.contentPreviewUrl;
    this.cosmetics = this.data.cosmetics;
    this.cosmeticBrandId = this.data.cosmeticBrandId;
    this.currentEdition = this.data.currentEdition;
    this.featuredFileId = this.data.featuredFileId;
    this.files = this.data.files;
    this.illustrationFileId = this.data.illustrationFileId;
    this.availableQuantity = this.data.availableQuantity;
    this.maxQuantityPerOrder = this.data.maxQuantityPerOrder;
    this.name = this.data.name;
    this.password = this.data.password;
    this.price = this.data.price;
    this.slug = this.data.slug;
    this.status = this.data.status;
    this.symbolFileId = this.data.symbolFileId;
    this.publishedAt = this.data.publishedAt;
  }
}
